import axios from 'axios';
import authHeader from "@/service/auth-header";

class DashboardService {

    async countClientsForCompany(companyId) {
        return await axios.get(`/api/client1/data/clients/${companyId}`, {headers: authHeader()})
    }

    async countTasksForCompany(companyId) {
        return await axios.get(`/api/data/tasks/${companyId}`, {headers: authHeader()})
    }

    async countClientProductsForCompany(companyId) {
        return await axios.get(`/api/client1/data/products/${companyId}`, {headers: authHeader()})
    }

    async getTasksForUser(userId, startDate, endDate) {
        return await axios.get(`/api/data/tasks/user/${userId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getProcessDurationForUser(userId, startDate, endDate) {
        return await axios.get(`/api/data/tasks/process/user/${userId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getTaskPerformanceForUser(userId, startDate, endDate) {
        return await axios.get(`/api/data/tasks/performance/user/${userId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getFinancialSummaryForCompany(companyId, startDate, endDate) {
        return await axios.get(`/api/data/financial/summary/company/${companyId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getTransactionSummaryForCompany(companyId, startDate, endDate) {
        return await axios.get(`/api/data/financial/transaction/summary/company/${companyId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getDetailedTransactionSummaryForCompany(companyId, startDate, endDate) {
        return await axios.get(`/api/data/financial/transaction/detailed/company/${companyId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getAppInvPaySummaryForCompany(companyId, startDate, endDate) {
        return await axios.get(`/api/data/financial/transaction/appinvpay/company/${companyId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getAppDetailForCompany(companyId, startDate, endDate) {
        return await axios.get(`/api/data/appointment/detail/company/${companyId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getPractitionerTransactionSummaryForCompany(companyId, startDate, endDate, selectedPractitioner) {
        return await axios.get(`/api/data/financial/transaction/summary/company/practitioner/${companyId}/${startDate}/${endDate}/${selectedPractitioner}`, {headers: authHeader()})
    }

    async getFinancialSummaryOverThreeMonthsForCompany(companyId) {
        return await axios.get(`/api/data/financial/summary/company/threemonths/${companyId}`, {headers: authHeader()})
    }

    async getFinancialSummaryAlltimeForCompany(companyId) {
        return await axios.get(`/api/data/financial/summary/company/alltime/${companyId}`, {headers: authHeader()})
    }

}

export default new DashboardService();
